<template>
	<page-content-layout class="movings" title="Movings">
		<button-view slot="tools" label="Opret" @click="select" />
		<div class="layout">
			<date-picker-std-view v-model="date" class="date" @browse="updateState" />
			<perfect-scrollbar class="tasks" name="task" tag="div" :style="{
				gridRow: search == '' && info != 'summary' ? '4' : '2 / 4',
				transition: 'grid-row 250ms'
			}">
				<transition-group name="task" tag="div">
					<div v-for="(task, i) in _tasks" :key="i" :class="['task', 'move']">
						<div class="color" :style="{ backgroundColor: task.color }"></div>
						<div class="name">{{ task.name }}<span :style="{ backgroundColor: task.color }">{{ task.abbr }}</span></div>
						<div class="info">
							<div v-if="task.start != task.stop" class="block">
								<div class="label">Fra</div>
								<div class="value">{{ task.start | date }}</div>
							</div>
							<div v-if="task.start != task.stop" class="block">
								<div class="label">Til</div>
								<div class="value">{{ task.stop | date }}</div>
							</div>
							<div v-if="task.start == task.stop" class="block">
								<div class="label">Dato</div>
								<div class="value">{{ task.start | date }}</div>
							</div>
						</div>
						<div class="buttons">
							<div @click="reject(task.id)">Afvis</div>
							<div @click="approve(task.id)">Godkend</div>
						</div>
					</div>		
					<spinner-view v-if="_tasks == null" />	
				</transition-group>
			</perfect-scrollbar>
			<new-table-view :slim="true" class="list" ref="table" :columns="_columns" :items="_items" @itemClick="itemClick" @delete="itemDelete" @leave="setLeave" @colclick="colclick" />
		</div>
	</page-content-layout>
</template>

<script>
	import merge from '../functions/merge'

	import NewTableView from '../views/NewTableView'

	import ContextPopupView from '../views/ContextPopupView'

	import SurveyTaskModel from '../model/SurveyTask'
	import SurveyTaskWindow from '../windows/SurveyTaskWindow'
	import LeaveWindow from '../windows/LeaveWindow'

	import MoveTaskModel from '../model/MoveTask'
	import MoveTaskWindow from '../windows/MoveTaskWindow'

	import CourierTaskModel from '../model/CourierTask'
	import CourierTaskWindow from '../windows/CourierTaskWindow'

	import TaskModel from '../model/Task'
	import TaskWindow from '../windows/TaskWindow'

	import DatePickerStdView from '../views/MonthPickerStdView'

	import { bus } from '../../bus'

    export default {
		data() {
			return {
				date: (new Date()).format('Y-m-d'),
				items: null,
				colors: [],
				status: [],
				state: [],
				types: [],
				requests: [],
				roles: [],
				holidays: [],
				role: 'all'
			};
		},
		components: {
			'NewTableView': NewTableView,
			'DatePickerStdView': DatePickerStdView
		},
		watch: {
			date(n, o) {
				this.items = null;
				this.update();
			}
		},
		computed: {
			_columns() {
				var cols = [
					{
						label: this._roles_table[this.role],
						options: this._roles,
						name: 'name',
						weight: 16,
						template: {
							name: 'profile',
							default: '',
							params: {
								photo: {
									name: ['_links', 'photo_48x48', 'href']
								},
								name: {
									name: 'name'
								},
								title: {
									name: 'title'
								}
							}
						}
					}
				];

				var d = new Date(this.date);
				var m = d.getMonth();
				d.setDate(1);

				while (m == d.getMonth()) {
					let isHoliday = this.holidays.find(h => h.date == d.format('Y-m-d'));
					let idx = cols.length;

					let avail = this._items.reduce((acc, item) => {
						if (item[idx].label == 'ARB') {
							acc += 1;
						}

						return acc;
					}, 0);

					let half = this._items.reduce((acc, item) => {
						if (item[idx].time_from !== null && item[idx].time_to !== null) {
							acc += 1;
						}

						return acc;
					}, 0);

					cols.push({
						label: d.getDate(),
						color: d.getDay() == 0 || d.getDay() == 6 || isHoliday ? 'red' : 'black',
						over: d.getDay() == 1 ? `U${d.getWeek(1)}` : '',
						under: `<span style="color: #4cb050;">${avail + (half > 0 ? ' *' : '')}</span>`,
						name: d.getDate(),
						align: 'center',
						weight: 2,
						background: d.getDay() == 0 || d.getDay() == 6 || isHoliday ? 'rgba(247, 34, 62, 0.067)' : 'none',
						template: {
							name: 'leave',
							params: {
								label: {
									name: [d.getDate(), 'label']
								},
								color: {
									name: [d.getDate(), 'color']
								},
								color2: {
									name: [d.getDate(), 'color2']
								},
								leave_type_id: {
									name: [d.getDate(), 'leave_type_id']
								},
								id: {
									name: ['id']
								},
								day: {
									data: d.getDate()
								},
								time_from: {
									name: [d.getDate(), 'time_from']
								},
								time_to: {
									name: [d.getDate(), 'time_to']
								},
							}
						}
					});

					d.setDate(d.getDate() + 1);
				}

				cols.push({
					label: '',
					name: 'pad',
					default: ''
				});

				return cols;
			},
			_roles_table() {
				return this._roles.reduce((acc, item) => {
					if (item !== null) acc[item.value] = item.label;
					return acc;
				}, {});
			},
			_roles() {
				var r = [
					{
						label: 'Alle',
						value: 'all',
						highlight: true,
					},
					null
				];

				

				for (var i = 0; i < this.roles.length; ++i) {
					r.push({
						label: this.roles[i].label,
						value: this.roles[i].name
					});
				}

				return r;
			},
			_items() {
				var r = [];
				var e;

				if (this.items !== null) {
					for (var i = 0; i < this.items.length; ++i) {
						e = this.items[i];

						
						
						if (this.role == 'all' || (e.roles && e.roles[this.role] && e.roles[this.role].enabled)) {
							r.push(e);
						}
					}
				}

				return r;
			},
			_tasks() {
				return this.requests;
			},
			_status() {
				var r = [];

				for (var i = 0; i < this.status.length; ++i) {
					r[this.status[i].name] = this.status[i].label;
				}

				return r;
			},
			_types() {
				var r = [];

				for (var i = 0; i < this.types.length; ++i) {
					r[this.types[i].name] = this.types[i].label;
				}

				return r;
			},
			_typesFull() {
				var r = [];

				for (var i = 0; i < this.types.length; ++i) {
					r[this.types[i].name] = this.types[i];

					if (this.types[i].super == 'general') {
						r[this.types[i].name].window 	= TaskWindow;	
						r[this.types[i].name].model 	= TaskModel; 
					} else {
						r[this.types[i].name] = this.types[i];

						switch (this.types[i].name) {
							case 'survey': 		r[this.types[i].name].window = SurveyTaskWindow;	r[this.types[i].name].model = SurveyTaskModel; 		break;
							case 'move': 		r[this.types[i].name].window = MoveTaskWindow; 		r[this.types[i].name].model = MoveTaskModel;		break;
							//case 'compound': 	r[this.types[i].name].window = CompoundTaskWindow; 	r[this.types[i].name].model = CompoundTaskModel;	break;
							case 'pickup': 		r[this.types[i].name].window = CourierTaskWindow; 	r[this.types[i].name].model = CourierTaskModel;		break;
							case 'delivery':	r[this.types[i].name].window = CourierTaskWindow; 	r[this.types[i].name].model = CourierTaskModel;		break;
						}
					}
				}

				return r;
			},
			_state() {
				var r = [];

				for (var date in this.state) {
					var s = this.state[date];

					r.push({
						date: date,
						color: 'gray',
						label: ''
					});
				}

				return r;
			},
			_statusColors() {
				var r = [];

				for (var i = 0; i < this.status.length; ++i) {
					r[this.status[i].name] = this._colors[this.status[i].color];
				}

				return r;
			},
			_typeColors() {
				var r = [];

				for (var i = 0; i < this.types.length; ++i) {
					r[this.types[i].name] = this.types[i].color;
				}

				return r;
			},
			_statusDesc() {
				var r = [];

				for (var i = 0; i < this.status.length; ++i) {
					r[this.status[i].name] = this.status[i].desc;
				}

				return r;
			},
			_colors() {
				var r = [];

				for (var i = 0; i < this.colors.length; ++i) {
					r[this.colors[i].name] = this.colors[i].color;
				}

				return r;
			}
		},
		methods: {
			colclick(col, opt) {
				
				this.role = opt.value;
			},
			actions(employeeId, day, leaveTypeId) {
				var r = [];

				var self = this;

				for (var i = 0; i < this.types.length; ++i) {
					r.push(
						function () {
							var j = i;

							return {
								label: self.types[j].name,
								action: async function () {
									var leaveTypeId = self.types[j].id;
									var date = (new Date(self.date)).format('Y-m-') + day.toString().padStart(2, '0');
									

									var r = await self.axios.put('/employees/leave/', {
										id: employeeId,
										leave_type_id: leaveTypeId,
										from: date,
										to: date
									});

									self.update();
								}
							};
						}(),
					);
				}

				r.push(null);

				r.push(
					function () {
						var date = (new Date(self.date)).format('Y-m-') + day.toString().padStart(2, '0');

						console.log(employeeId, leaveTypeId);

						return {
							label: 'Rediger',
							action: async function () {
								self.$store.state.windowStack.push(LeaveWindow, {
									entity: {
										from_date: date, 
										to_date: date,
										leave_type_id: parseInt(leaveTypeId),
										employee_id: parseInt(employeeId),
										time: false,
									},
									submit: async function (ent) {
										console.log(ent);

										var r = await self.axios.put('/employees/leave/', {
											id: ent.employee_id,
											leave_type_id: ent.leave_type_id,
											from: ent.from_date,
											to: ent.to_date,
											time: ent.time,
											from_time: ent.from_time,
											to_time: ent.to_time,
										});

										self.$store.state.windowStack.pop();

										self.update();
									}
								});
							}
						};
					}(),
				);

				r.push(
					function () {
						var j = i;

						return {
							label: 'Nulstil',
							action: async function () {
								var leaveTypeId = null;
								var date = (new Date(self.date)).format('Y-m-') + day.toString().padStart(2, '0');
								

								var r = await self.axios.put('/employees/leave/', {
									id: employeeId,
									leave_type_id: leaveTypeId,
									from: date,
									to: date
								});

								self.update();
							}
						};
					}(),
				);

				return r;
			},
			createButtonClick: function () {
				var contacts = this;

				this.$store.state.windowStack.push(Window, {
					onChange: function (ent) {
						
						

						contacts.update();
					}
				});
			},
			itemClick: function (item) {
				//var contacts = this;

				/*this.$store.state.windowStack.push(LeaveWindow, {id: item.id, form: true, onChange: function () {
					//contacts.update();
				}});*/
			},
			itemDelete(item) {
				if (!confirm('Sikker?')) return;

				var view = this;

				this.axios
					.delete('/employees/' + item.id + '/')
					.then(function (r) {
						

						if (r.status >= 200 && r.status < 300) {
							view.update();
						}

						
					}, function (err) {
						
						
						var r = err.response;

						if (r.status == 422) {
							alert(r.data);
						} else {
							alert('Server Error');
						}
					});	
			},
			action: function (name, id) {
				if (name == 'delete' && confirm('Sure?')) {
					

					var contacts = this;

					this.axios
						.delete('/employees/' + id + '/')
						.then(function () {
							contacts.update();
						}, function () {
							alert('Could not delete the item');
						});
				}
			},
			update() {
				var contacts = this;

				//contacts.items = null;
				contacts.requests = [];

				var d = new Date(this.date);

				this.axios
					.get('/employees/leave/' + d.getFullYear() + '/' + (d.getMonth() + 1) + '/')
					.then(function (r) {
						
						contacts.items = r.data;
					});

				this.axios
					.get('/employees/leave/requests/')
					.then(function (r) {
						
						contacts.requests = r.data;
					});

				this.axios
					.get('/employees/holidays/' + d.getFullYear() + '/' + (d.getMonth() + 1) + '/')
					.then(function (r) {
						contacts.holidays = r.data;
					});
			},
			async approve(item) {
				

				await this.axios.put('/employees/leave/requests/' + item + '/approve/');
				this.update();
			},
			async reject(item) {
				

				await this.axios.put('/employees/leave/requests/' + item + '/deny/');
				this.update();
			},
			setLeave(event, id, day, leaveTypeId) {
				
				
				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.target,
					align: 'left',
					actions: this.actions(id, day, leaveTypeId)
				});
			}
		},
		mounted() {
			this.axios.put('/activity/leave/');

			this.update();

			var self = this;

			this.axios
				.get('/tasks/status/')
				.then(function (r) {
					self.status = r.data._items;
				});

			this.axios
				.get('/employees/leave/types/')
				.then(function (r) {
					self.types = r.data._items;
				});

			this.axios
				.get('/config/status/colors/')
				.then(function (r) {
					self.colors = r.data._items;
				});

			this.axios
				.get('/employees/roles/')
				.then(function (r) {
					self.roles = r.data._items;
				});

			bus.$on('update', function () {
				self.update();
			});

			bus.$on('clear', function () {
				self.items = null;
			});
		},
		beforeRouteLeave(to, from, next) {
			bus.$off('update');
			bus.$off('clear');

			next();
		}
    }
</script>

<style lang="scss" scoped>
	.layout {
		width: 100%;
		height: 100%;
		display: grid;
		grid-template-columns: 320px 1fr;
		grid-template-rows: 250px 1fr;

		& > .new-table-view {
			width: 100%;
			height: 100%;
			
		}

		& > .tasks {
			border-top: 1px solid #cecece;
			padding: 20px;

			& > * > .task {
				box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);

				background-color: white;
				overflow: hidden;
				margin-bottom: 20px;
				border-radius: 5px;
				display: grid;
				grid-template-columns: [left] 5px [after-color] 275px [right];
				grid-template-rows: [top] auto [after-name] auto [after-info] auto [after-buttons] auto [bottom];

				&:last-child {
					margin-bottom: 0;
				}

				& > .color {
					grid-column: left / after-color;
					grid-row: top / bottom;
				}

				& > .name {
					grid-column: after-color / right;
					grid-row: top / after-name;
					padding: 10px;
					font-weight: bold;
					position: relative;

					& > span {
						position: absolute;
						background-color: #f7223f;
						color: white;
						font-size: 12px;
						margin: 5px 5px 0 0;
						padding: 0 10px 0 10px;
						font-weight: normal;
						right: 2px;
						top: 2px;
						line-height: 28px;
						border-radius: 2px;
					}
				}

				& > .info {
					grid-column: after-color / right;
					grid-row: after-name / after-info;
					padding: 0 10px 10px 10px;
					border-top: 1px solid #f0f0f0;

					& > .block {
						padding-top: 5px;
						display: grid;
						grid-template-columns: 1fr 2fr;

						& > .label {

						}

						& > .value {
							text-align: right;
							font-weight: bold;
						}
					}
				}

				& > .buttons {
					border-top: 1px solid #f0f0f0;
					grid-column: after-color / right;
					grid-row: after-info / after-buttons;
					padding: 0 5px 0 5px;
					display: grid;

					grid-template-columns: 1fr 1fr;		

					& > div {
						line-height: 40px;
						text-align: center;
						cursor: pointer;

						&:last-child {
							border-left: 1px solid #f0f0f0;
						}
					}			
				}

				& > .secondary {
					grid-column: after-zip / right;
					grid-row: after-name / after-zip;
					padding: 0 5px 5px 5px;
					text-align: right;
				}

				& > .arrow {
					grid-column: after-info / right;
					grid-row: top / after-zip;

				}

				& > .teams {
					grid-column: after-color / right;
					grid-row: after-zip / bottom;

					& > .team {
						border-top: 1px solid #f0f0f0;
						padding: 5px;

						& > .header {
							padding: 5px;
							border-radius: 3px;
							cursor: grab;
							color: white;

							& > .title {
								font-weight: bold;
							}

							& > .desc {
								width: 100%;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
								margin-top: 5px;
								font-style: italic;
							}
						}

						& > .reqs {
							& > .row {
								display: grid;
								grid-template-columns: 215px 50px;
								margin-top: 5px;

								& > .title, & > .state {
									font-size: 14px;
								}

								& > .title {
									overflow: hidden;
									text-overflow: ellipsis;
									white-space: nowrap;
								}

								& > .state {
									text-align: right;
								}

								&.header {
									margin-top: 10px;

									&::first-child {
										margin-top: 0px;
									}

									& > .title, & > .state {
										font-size: 16px;
									}
								}
							}
						}
					}
				}
			}
		}
	}

	.date {
		grid-column: 1;
		grid-row: 1;
		background-color: #f0f0f0;
		padding: 30px;
	}

	.tasks {
		grid-column: 1;
		grid-row: 2 / 3;
		background-color: #f0f0f0;		
	}

	.list {
		grid-column: 2 / 3;
		grid-row: 1 / 3;
		border-left: 1px solid #cecece;
	}
</style>